export default "/images/BC-Checklist.png?0cbfa515bf72894cbb283a0d51d3351c";